<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Crear Producto</span>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="8" md="8">
              <v-text-field
                v-model="editedItem.nombre"
                label="Nombre"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="editedItem.codigo"
                label="Codigo"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="editedItem.preciosugerido"
                label="Precio Sugerido"
                prefix="Q "
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="editedItem.stockactual"
                label="Stock Actual"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="$router.go(-1)">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="postItem">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import Swal from 'sweetalert2'
import { mapGetters } from 'vuex'
export default {
    data: () => ({
      editedItem: {
        codigo: '',
        nombre: '',
        ubicacion: '',
        descripcion: '',
        preciocompra:1,
        preciosugerido:1,
        preciominimo:1,
        stockminimo: 1,
        stockactual: 1,
        tipo:'B',
        idcategoria: 1,
      },
      defaultItem: {
        codigo: '',
        nombre: '',
        ubicacion: '',
        descripcion: '',
        preciocompra:1,
        preciosugerido:1,
        preciominimo:1,
        stockminimo: 1,
        stockactual: 1,
        tipo:'B',
        idcategoria: 1
      },
    }),
    created(){
        this.initialize();
    },
    computed:{
        ...mapGetters(['getTokenUser','getUrlApi'])
    },
    methods:{
     async initialize () {
        await this.$store.dispatch('setAllCategorias')       
      },
     async postItem(){

        try {
           await axios.post(`${this.getUrlApi}/articulos`,this.editedItem,this.getTokenUser)
           this.editedItem = Object.assign({}, this.defaultItem)
           Swal.fire('Registro Creado','','success') 
           this.$router.go(-1)
        } catch (error) {
            console.log(error)
            Swal.fire('Error al crear registro','','error') 
        }
        
      },
    }
}
</script>